var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.allAccountTransfer}},[_c('span',[_vm._v(_vm._s(_vm.$t("store.wallet.back_wallet")))])])}
var staticRenderFns = []

export { render, staticRenderFns }